import axios from './axios';
import { API_URL } from '../config/env';

export async function login(email, password) {
  const res = await axios.post(`${API_URL}/api/auth/login`, { email, password });
  localStorage.setItem('token', res.data.token);
  return res.data;
}

export function logout() {
  const token = localStorage.getItem('token');
  localStorage.removeItem('token');
  if (token) {
    axios
      .post(`${API_URL}/api/auth/logout`, {}, { headers: { Authorization: `Bearer ${token}` } })
      .catch(() => {});
  }
}

export function getToken() {
  return localStorage.getItem('token');
}
